Jelly.Interface.Generate_Lightbox = function()
{
	// TODO: Possibly add something built in, via something like 
/*

return [Format as "Javascript String"]
	<div>
		yay.
	</div>
[/Format];
*/
	// TODO: Remove below
	return Jelly.Interface.Generate_Browser_Control({Browser_Control_ID: "Lightbox"});
}
